import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-section">
              <img 
                src="/assets/HEGXIB.NIGERIA.png" 
                alt="HEGXIB Nigeria" 
                className="footer-logo"
              />
              <h3>HEGXIB Nigeria</h3>
            </div>
            <p>Empowering Nigerian businesses through innovative digital solutions and technology services.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p><FaMapMarkerAlt /> Oyo, Nigeria</p>
            <p><FaEnvelope /> ng@hegxib.me</p>
            <p><FaPhone /> +213 (0) 66 00 37 773</p>
          </div>
          
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://facebook.com/hegxib" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://twitter.com/hegxib" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>
              <a href="https://linkedin.com/company/hegxib" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://instagram.com/hegxib" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 HEGXIB Nigeria. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

